module.exports = __webpack_public_path__ + "static/img/853_phase_function_Paper_Points.9c5e4c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/853_phase_function_Paper_Points.png
// module id = +GNK
// module chunks = 0